<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module title="기본정보(담당자 정보)" v-model="form.stdInfo" :board="this.board" :is-print="isPrint" @selectField="selectField" />

    <!-- 학교정보 -->
    <div>
      <h5 class="mt-6 mb-4"><i class="dot"></i> 학교정보</h5>
      <div class="writeGridContainer">
        <div>
          <div>지역</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_1 }}</p>
          <ml-input v-else v-model="form.inputA_1" readonly />
        </div>
        <div>
          <div>구분(급별)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_2 }}</p>
          <ml-input v-else v-model="form.inputA_2" readonly />
        </div>
        <div>
          <div>조사일</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_3 }}</p>
          <date-selector v-else v-model="form.inputA_3" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!-- 예비조사 결과 -->
    <div>
      <h5 class="mt-6 mb-4"><i class="dot"></i> 예비조사 결과</h5>
      <div class="writeGridContainer">
        <div>
          <div>예비조사 물질</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_1 }}</p>
          <ml-input v-else v-model="form.inputB_1" :readonly="board.readonly" />
        </div>
        <div>
          <div>본조사 제외 사유</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_2 }}</p>
          <ml-input v-else v-model="form.inputB_2" :readonly="board.readonly" />
        </div>
        <div>
          <div>측정결과</div>
          <radio-text-input
            :readonly="board.readonly"
            :isPrint="isPrint"
            radioName="radio_1"
            :renderData="[
              { textInput: false, value: '적합' },
              { textInput: false, value: '부적합' },
            ]"
            v-model="form.inputB_3"
          />
        </div>
      </div>
    </div>

    <!-- 본조사 결과 -->
    <div>
      <h5 class="mt-6 mb-4"><i class="dot"></i> 본조사 결과</h5>
      <div class="writeGridContainer">
        <div>
          <div>본조사 측정물질 (노출기준)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_1 }}</p>
          <ml-input v-else v-model="form.inputC_1" :readonly="board.readonly" />
        </div>
        <div>
          <div>측정결과</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_2 }}</p>
          <ml-input v-else v-model="form.inputC_2" :readonly="board.readonly" />
        </div>
        <div></div>
        <div>
          <div>본조사 대상물질 (노출기준)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_3 }}</p>
          <ml-input v-else v-model="form.inputC_3" :readonly="board.readonly" />
        </div>
        <div>
          <div>측정결과</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_4 }}</p>
          <ml-input v-else v-model="form.inputC_4" :readonly="board.readonly" />
        </div>
        <div>
          <div>측정결과</div>
          <radio-text-input
            :readonly="board.readonly"
            :isPrint="isPrint"
            radioName="radio_2"
            :renderData="[
              { textInput: false, value: '해당없음' },
              { textInput: false, value: '적합' },
              { textInput: false, value: '부적합' },
            ]"
            v-model="form.inputC_5"
          />
        </div>
        <div>
          <div>소음(80db)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_6 }}</p>
          <ml-input v-else v-model="form.inputC_6" :readonly="board.readonly" />
        </div>
        <div>
          <div>측정결과</div>
          <radio-text-input
            :readonly="board.readonly"
            :isPrint="isPrint"
            radioName="radio_3"
            :renderData="[
              { textInput: false, value: '적합' },
              { textInput: false, value: '재측정(80db)' },
            ]"
            v-model="form.inputC_7"
          />
        </div>
        <div></div>
        <div>
          <div>재측정항목</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_8 }}</p>
          <ml-input v-else v-model="form.inputC_8" :readonly="board.readonly" />
        </div>
        <div>
          <div>비고</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_9 }}</p>
          <ml-input v-else v-model="form.inputC_9" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import EmployeeSelector from "@/components/selector/EmployeeSelector.vue";
import DateSelector from "@/components/selector/DateSelector";
import RadioTextInput from "@/components/radio/RadioTextInput";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
    EmployeeSelector,
    DateSelector,
    RadioTextInput,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",

        inputB_1: "",
        inputB_2: "",
        inputB_3: {},

        inputC_1: "",
        inputC_2: "",
        inputC_3: "",
        inputC_4: "",
        inputC_5: {},
        inputC_6: "",
        inputC_7: {},
        inputC_8: "",
        inputC_9: "",

        fileList: [],
      },
    };
  },
  methods: {
    selectField(data) {
      const si = ["목포", "여수", "순천", "나주", "광양", "담양", "곡성", "구례", "고흥", "보성", "화순", "장흥", "강진", "해남", "영암", "무안", "함평", "영광", "장성", "완도", "진도", "신안"];

      si.map((_si) => {
        if (data.address.includes(_si)) {
          this.form.inputA_1 = _si;
        }
      });

      this.form.inputA_2 = data.facility_category.cat3;
    },
  },
};
</script>

<style scoped lang="scss"></style>
